import { AppGlobals } from 'src/app/app.globals';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export enum BaseRequestMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE"
}

export class BaseService {
    protected _configurations: any = {};
    protected _services: any;
    private _httpClient: HttpClient;
    private _defaultHeaders: Object;

    constructor(protected httpClient: HttpClient) {
        this._httpClient = httpClient;
        this._configurations = AppGlobals.getAppConfigurations();
        this._services = this._configurations.services;
        this._defaultHeaders = this._services.backend.defaultHeaders;
    }

    callService<T>(method: BaseRequestMethod, serviceName: string, data?: any, context: any = null, contentType = 'application/json', access_token: string = "") {
        let contextService = this;
        let salt = (new Date()).getTime();
        let url = contextService._services.backend.host + serviceName + '?' + salt;
        let body = { ...contextService._services.backend.requestBody };
        let headers = {
            'Content-Type': (typeof contentType == 'undefined' || (typeof contentType != 'undefined' && contentType == null)) ? 'application/json' : contentType,
            'Authorization': 'Bearer ' + access_token
        };

        if (context != null) {
            body.context = context;
        }

        if (data != null) {
            body.data = data;
        }

        let handlerSerivce = null;

        Object.keys(contextService._defaultHeaders).forEach(header => {
            headers[header] = contextService._defaultHeaders[header];
        });

        switch (method) {
            case BaseRequestMethod.GET:
                handlerSerivce = contextService._httpClient.get<T>(url, { headers: new HttpHeaders(headers) });
                break;
            case BaseRequestMethod.POST:
                handlerSerivce = contextService._httpClient.post<T>(url, body, { headers: new HttpHeaders(headers) });
                break;
            case BaseRequestMethod.PUT:
                handlerSerivce = contextService._httpClient.put<T>(url, body, { headers: new HttpHeaders(headers) });
                break;
            case BaseRequestMethod.DELETE:
                handlerSerivce = contextService._httpClient.request<T>('delete', url, { headers: new HttpHeaders(headers), body: body });
                break;
        }

        return handlerSerivce;
    }

    submitForm<T>(url: string, form?: any): Observable<T> {
        let contextService = this;
        if (contextService == null) {
            return null;
        }
        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return contextService._httpClient.post<T>(url, form, { headers: new HttpHeaders(headers) });
    }
}